import { useEffect, useState } from 'react';

import FulfilmentProviderOrigin from '@/shared/types/fulfilment/fulfilmentProviderOrigin.type';

type Args = {
  fulfilmentOrigin?: FulfilmentProviderOrigin;
};

const usePickupDetailsForm = ({ fulfilmentOrigin }: Args) => {
  const now = new Date();
  const nextDay = new Date(now);
  nextDay.setDate(now.getDate() + 1);

  const ts_ready_at = new Date(nextDay);
  ts_ready_at.setHours(10, 0, 0, 0);

  const ts_ready_until = new Date(nextDay);
  ts_ready_until.setHours(17, 0, 0, 0);

  const [pickupDetailsForm, setPickupDetailsForm] = useState({
    pre_scheduled_pickup: false,
    ts_ready_at,
    ts_ready_until,
    pickup_location: '',
    contact_name: '',
    contact_phone_number: {
      number: '',
      extension: '',
    },
  });

  useEffect(() => {
    if (fulfilmentOrigin) {
      setPickupDetailsForm((prev) => ({
        ...prev,
        contact_phone_number: {
          ...prev.contact_phone_number,
          number: fulfilmentOrigin.phone_number,
        },
        pickup_location: fulfilmentOrigin.display_address,
        contact_name: fulfilmentOrigin.contact_name,
      }));
    }
  }, [fulfilmentOrigin]);

  return {
    pickupDetailsForm,
    setPickupDetailsForm,
  };
};

export default usePickupDetailsForm;
